import { CaseState } from 'app/area/case/types-store';
import { getAllEntitiesAtPath } from 'app/infrastructure/store';
import { getValue } from 'app/infrastructure/ui/form/selectors';
import { getCaseData } from 'app/infrastructure/ui/renderer/resolvers';
import { tableName, columnName } from 'app/area/case/case-data-model';

export const connectedCasesActionCount = (caseState: CaseState, uiEngineProps: any) => {
  const resolveContext = uiEngineProps.resolveContext;
  const data = getCaseData(caseState, uiEngineProps);
  const actionEntities = getAllEntitiesAtPath(data, [...resolveContext.path, tableName.connectedActionView]);
  const closedActionEntities = actionEntities.filter(e => !!getValue(e, columnName[tableName.connectedActionView as any]
                                .numberOfConnectedClosedActions).value);

  return {
    actionCount: actionEntities.length,
    closedActionCount: closedActionEntities.length
  };
};

export interface ConnectedCasesActionCountShape {
  actionCount: number;
  closedActionCount: number;
}
